import type { AgentComponentType } from '@reach/shared-types/agent-components';
import { useParams } from 'react-router-dom';
import { ComponentEditor } from './ComponentEditor';
import { SavedComponentEditor } from './SavedComponentEditor';

interface ComponentPageProps {
  type: AgentComponentType;
}

export const ComponentPage = ({ type }: ComponentPageProps) => {
  const { componentId } = useParams();
  const componentIsNew = componentId === undefined;

  if (componentIsNew) {
    return <ComponentEditor type={type} />;
  }
  return <SavedComponentEditor type={type} componentId={componentId} />;
};
